import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "select2", "spinner" ]

  connect() {
    this.inputTargets.forEach(t => {
      t.addEventListener('change', e => this.submit())
    })

    this.select2Targets.forEach(t => {
      // TomSelect dispara eventos nativos de 'change' no elemento select
      t.addEventListener('change', e => this.submit())
    })
  }

  submit() {
    this.showSpinner()
    this.element.submit()
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
    }
  }
}
